import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";
import moment from "moment";
import "moment/locale/th";
import { formatNumber } from "../../../utils/formatNumber";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew.ttf",
    italics: "THSarabunNew.ttf",
    bolditalics: "THSarabunNew.ttf",
  },
};

export function generateDeliveryNoteSalePdfBlob(transaction) {
  const totalWeight = transaction.items.reduce(
    (s, i) => s + (i.weight || 0),
    0
  );
  const totalDeductWeight = transaction.items.reduce(
    (s, i) => s + (i.deductWeight || 0),
    0
  );
  const totalNetWeight = transaction.items.reduce(
    (s, i) => s + (i.netWeight || 0),
    0
  );

  const docDefinition = {
    content: [
      { text: "ใบขนส่งสินค้า", style: "header" },
      {
        text: `${transaction?.branch?.companyName || ""}\n${transaction?.branch?.address || ""}
โทร: ${transaction?.branch?.phoneNumber || ""}\nเปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
        margin: [0, 10, 0, 10],
      },
      {
        columns: [
          [
            {
              text: `ชื่อขนส่งสินค้า: ${transaction.shipping.shippingName || "-"}`,
            },
            { text: `เลขที่ตั๋ว: ${transaction.billNumber || "-"}` },
            { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
            {
              text: `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ${transaction.customerName || "-"}`,
            },
            { text: `${transaction.customer?.address || ""}` },
            {
              text: transaction.customer?.phone
                ? `${transaction.customer.phone.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "",
            },
          ],
          [
            {
              text: transaction.createdAt
                ? (() => {
                    const d = moment(transaction.createdAt).locale("th");
                    return `วันที่เปิดตั๋ว: ${d.format("DD/MM/")}${d.year() + 543} ${d.format("HH:mm")}`;
                  })()
                : "วันที่เปิดตั๋ว: -",
            },
            {
              text: transaction.shipping?.createdAt
                ? (() => {
                    const d = moment(transaction.shipping.createdAt).locale(
                      "th"
                    );
                    return `วันที่ขาย: ${d.format("DD/MM/")}${d.year() + 543} ${d.format("HH:mm")}`;
                  })()
                : "วันที่ขาย: -",
            },
            {
              text: `เลขตู้ขนส่ง: ${transaction.shipping?.transportBoxNumber || "-"}`,
            },
            { text: `ชื่อคนขับ: ${transaction.shipping?.driverName || "-"}` },
            {
              text: `รถขนส่ง: ${transaction.car?.type || "-"} ${transaction.car?.license || "-"}`,
            },
            {
              text: transaction.shipping?.phoneNumber
                ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "โทรศัพท์: -",
            },
          ],
        ],
        margin: [0, 0, 0, 10],
      },
      {
        table: {
          widths: ["*", "auto", "auto", "auto", "auto"],
          body: [
            [
              { text: "รายการ", bold: true },
              { text: "รายการทั้งหมด", bold: true, alignment: "right" },
              { text: "รวม", bold: true, alignment: "right" },
              { text: "หัก", bold: true, alignment: "right" },
              { text: "สุทธิ", bold: true, alignment: "right" },
            ],
            [
              "น้ำหนักสินค้า",
              { text: "1", alignment: "left" },
              { text: formatNumber(totalWeight || 0), alignment: "right" },
              {
                text: formatNumber(totalDeductWeight || 0),
                alignment: "right",
              },
              { text: formatNumber(totalNetWeight || 0), alignment: "right" },
            ],
            [
              "น้ำหนักรถขนส่ง",
              "",
              {
                text: formatNumber(transaction.carHeavyWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(transaction.carLightWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(
                  (transaction.carHeavyWeight || 0) -
                    (transaction.carLightWeight || 0)
                ),
                alignment: "right",
              },
            ],
          ],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 10],
      },
      {
        text: `หมายเหตุ ${transaction.shipping?.note || "-"}`,
        margin: [0, 0, 0, 10],
      },
      {
        text: `เปิดตั๋วโดย ${transaction.openByNames || "-"}`,
        margin: [0, 0, 0, 20],
      },
      {
        columns: [
          {
            text: "ลงชื่อ: _________________________(ผู้ขนสินค้า)",
            alignment: "left",
          },
          {
            text: "ลงชื่อ: _________________________(ผู้เช็คสินค้า)",
            alignment: "right",
          },
        ],
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 10],
      },
    },
    defaultStyle: { font: "THSarabunNew", fontSize: 16 },
  };

  return new Promise((resolve) => {
    pdfMake.createPdf(docDefinition).getBlob((blob) => resolve(blob));
  });
}

export function generateDeliveryNoteSalePdf(transaction) {
  const totalWeight = transaction.items.reduce(
    (sum, item) => sum + (item.weight || 0),
    0
  );
  const totalDeductWeight = transaction.items.reduce(
    (sum, item) => sum + (item.deductWeight || 0),
    0
  );
  const totalNetWeight = transaction.items.reduce(
    (sum, item) => sum + (item.netWeight || 0),
    0
  );
  // const totalNetPrice = transaction.items.reduce(
  //   (sum, item) => sum + item.netPrice,
  //   0
  // );

  const docDefinition = {
    content: [
      { text: "ใบขนส่งสินค้า", style: "header" },

      {
        text: `${transaction?.branch?.companyName || ""}\n${transaction?.branch?.address || ""}
โทร: ${transaction?.branch?.phoneNumber || ""}\nเปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
        margin: [0, 10, 0, 10],
      },

      {
        columns: [
          [
            {
              text: `ชื่อขนส่งสินค้า: ${transaction.shipping.shippingName || "-"}`,
            },
            { text: `เลขที่ตั๋ว: ${transaction.billNumber || "-"}` },
            { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
            {
              text: `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ${
                transaction.customerName || "-"
              }`,
            },
            {
              text: `${transaction.customer?.address || ""}`,
            },
            {
              text: transaction.customer?.phone
                ? `${transaction.customer.phone.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "",
            },
          ],
          [
            {
              text: transaction.createdAt
                ? (() => {
                    const date = moment(transaction.createdAt).locale("th");
                    const buddhistYear = date.year() + 543;
                    return `วันที่เปิดตั๋ว: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                  })()
                : "วันที่เปิดตั๋ว: -",
            },
            {
              text: transaction.shipping.createdAt
                ? (() => {
                    const date = moment(transaction.shipping.createdAt).locale(
                      "th"
                    );
                    const buddhistYear = date.year() + 543;
                    return `วันที่ขาย: ${date.format("DD/MM/")}${buddhistYear} ${date.format("HH:mm")}`;
                  })()
                : "วันที่ขาย: -",
            },
            {
              text: `เลขตู้ขนส่ง: ${transaction.shipping.transportBoxNumber || "-"}`,
            },
            { text: `ชื่อคนขับ: ${transaction.shipping.driverName || "-"}` },
            {
              text: `รถขนส่ง: ${transaction?.car?.type || "-"} ${transaction?.car?.license || "-"}`,
            },
            {
              text: transaction.shipping?.phoneNumber
                ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "โทรศัพท์: -",
            },
          ],
        ],
        margin: [0, 0, 0, 10],
      },

      {
        table: {
          widths: ["*", "auto", "auto", "auto", "auto"],
          body: [
            [
              { text: "รายการ", bold: true },
              { text: "รายการทั้งหมด", bold: true, alignment: "right" },
              { text: "รวม", bold: true, alignment: "right" },
              { text: "หัก", bold: true, alignment: "right" },
              { text: "สุทธิ", bold: true, alignment: "right" },
            ],
            [
              "น้ำหนักสินค้า",
              { text: "1", alignment: "left" },
              {
                text: formatNumber(totalWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(totalDeductWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(totalNetWeight || 0),
                alignment: "right",
              },
            ],
            [
              "น้ำหนักรถขนส่ง",
              "",
              {
                text: formatNumber(transaction.carHeavyWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(transaction.carLightWeight || 0),
                alignment: "right",
              },
              {
                text: formatNumber(
                  (transaction.carHeavyWeight || 0) -
                    (transaction.carLightWeight || 0)
                ),
                alignment: "right",
              },
            ],
          ],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 10],
      },

      {
        text: `หมายเหตุ ${transaction.shipping.note || "-"}`,
        margin: [0, 0, 0, 10],
      },

      {
        text: `เปิดตั๋วโดย ${transaction.openByNames || "-"}`,
        margin: [0, 0, 0, 20],
      },

      {
        columns: [
          {
            text: "ลงชื่อ: _________________________(ผู้ขนสินค้า)",
            alignment: "left",
          },
          {
            text: "ลงชื่อ: _________________________(ผู้เช็คสินค้า)",
            alignment: "right",
          },
        ],
      },
    ],

    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 10],
      },
    },

    defaultStyle: {
      font: "THSarabunNew",
      fontSize: 16,
    },
  };

  pdfMake.createPdf(docDefinition).open();
}
